function getConfigCompoment () { return 'XLSFactory' }
function getStandardAttributes () { return null }

export default {
  getConfigCompoment,
  getStandardAttributes
}
